import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSheetPendingCount } from './use-binding';

/**
 * Header affordance for the review queue.
 *
 * Renders nothing when the queue is empty — a permanently-present control would fade into
 * the chrome, and the whole point is that its appearance means something needs a decision.
 */
export function ReviewBadge() {
  const { t } = useTranslation();
  const { data: count } = useSheetPendingCount();

  if (!count) return null;

  return (
    <Button
      asChild
      variant="ghost"
      size="sm"
      className="relative gap-1.5"
      aria-label={t('sheet_sync.pending_aria', { count })}
    >
      <Link to="/sheet-sync">
        <Inbox className="size-4" aria-hidden />
        <span className="inline-flex size-5 items-center justify-center rounded-full bg-destructive text-xs font-medium text-destructive-foreground">
          {count}
        </span>
      </Link>
    </Button>
  );
}
